export default __webpack_public_path__ + "static/media/assign-icon.c2213f36.svg";